import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/API/api.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  settings: SafeHtml = '';

  constructor(private apiService: ApiService,private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.loadSetting()
  }

  loadSetting(){
    this.apiService.vendorSettings().subscribe({
      next: response => {
        this.settings = this.sanitizer.bypassSecurityTrustHtml(
          response.settings.terms_and_conditions || ''
        );
      }, 
      error: (error: any) => {
        console.log(error);
      }
    });
  }
}
